module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "toc-bm"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/epigraph"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro"
    }
  }, [_vm._v("Introduction: The Future of Work Is You")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('span', {
    staticClass: "unibcn"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PART ONE:")])]), _vm._v(" THE "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("NEW")]), _vm._v(" NEW REALITIES OF AMERICA AT WORK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_vm._v("1. Work and the Pursuit of Happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_vm._v("2. The "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New")]), _vm._v(" New Realities of Work")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Economic Long View")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "unibcn"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PART TWO:")])]), _vm._v(" THE WORK/LIFE MATRIX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Mastering the Work/Life Matrix: Know Yourself, Set Your Goals, Play by Your Own Rules")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapi"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec1a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The Archetypes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bull"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("• The CH Types")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHET—“The Good Shepherd”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHES—“The Right-Hand Man or Woman”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHIT—“The Change Agent”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHIS—“The Sharp-Eyed Analyst”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bull"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("• The RH Types")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RHET—“The Bridge”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RHES—“The Maverick”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RHIT—“The Promoter”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RHIS—“The Empire Builder”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bull"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("• The CP Types")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CPET—“The Team Player”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CPES—“The Taskmaster”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CPIT—“The Steady Hand”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CPIS— “The Masterful Realist”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bull"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("• The RP Types")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RPET—“The Chief of Staff”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RPES—“Mr./Ms. Get It Done”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RPIT—“The Cocreator in Chief”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bulli"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RPIS—“The Groundbreaker”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapi"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Work/Life Mastery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "unibcn"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PART THREE:")])]), _vm._v(" MAKING DECISIONS WITH HEART AND SMARTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Resilience Is Everything: Recovering from Layoffs, Screwups, and Other Career Disasters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New")]), _vm._v(" New Realities of Job Search")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Hold ’Em or Fold ’Em? When to Stay in a Job, and When to Go")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "unibcn"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PART FOUR:")])]), _vm._v(" THE RIGHT WORK FOR AMERICA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Lifelong Learning, Lifelong Earning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Money and Morality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Retirement, Remixed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/thoughts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Thoughts: Reflections on Happiness on the Job and Off")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/resources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pointers and Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/data",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Data Dig: A Closer Look at the Archetypes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/authorbio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Farai Chideya")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0